import {RequestState} from "modules/enums";
import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getLeadersStore = (store: IStore) => store.leaders;

export const getLeadersCollection = createSelector([getLeadersStore], (leadersStore) => {
	return leadersStore.leaders;
});

export const isLoadedLeadersPicks = createSelector(
	[getLeadersStore],
	(streak) => streak.requestState === RequestState.Received
);
